import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import { normalize } from "normalizr";
import { disclaimersSchema } from "./disclaimers-schema";
import { v4 as uuidv4 } from "uuid";
import { getDisclaimers, getBrokerageDisclaimers, putBrokerageDisclaimers, putDisclaimers } from "../disclaimers-api";
import Err from "@Broker/@Routes/error";
import { SET_DISCLAIMERS, REMOVE_DISCLAIMER, ADD_DISCLAIMER, SET_DEFAULT_DISCLAIMER_ENABLED, UPDATE_DISCLAIMER as updateDisclaimer } from "./disclaimers-mutations";
import { GET_DISCLAIMERS_FILTERED } from "@Broker/@Modules/settings/disclaimers/store/disclaimers-getters";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
export const LOAD_DISCLAIMERS = "LOAD_DISCLAIMERS";
export const DELETE_DISCLAIMER = "DELETE_DISCLAIMER";
export const CREATE_DISCLAIMER = "CREATE_DISCLAIMER";
export const UPDATE_DEFAULT_DISCLAIMER_ENABLED = "UPDATE_DEFAULT_DISCLAIMER_ENABLED";
export const UPDATE_DISCLAIMER = "UPDATE_DISCLAIMER";
const actions = {
  [LOAD_DISCLAIMERS]: async (context, {
    isBrokerage
  }) => {
    try {
      const {
        disclaimers,
        defaultDisclaimerEnabled = null
      } = isBrokerage ? await getBrokerageDisclaimers() : await getDisclaimers();
      const {
        entities,
        result
      } = normalize(disclaimers, [disclaimersSchema]);
      context.commit(SET_DISCLAIMERS, {
        disclaimers: {
          byId: entities.disclaimers || {},
          allIds: result
        }
      });
      context.commit(SET_DEFAULT_DISCLAIMER_ENABLED, defaultDisclaimerEnabled != null ? defaultDisclaimerEnabled : context.getters[GET_DISCLAIMERS_FILTERED](false).length === 1);
    } catch (e) {
      Err.handle(e, context);
    }
  },
  [DELETE_DISCLAIMER]: async (context, {
    isBrokerage,
    id,
    defaultDisclaimerEnabled
  }) => {
    const oldDisclaimers = context.state.disclaimers;
    const oldDefaultDisclaimerEnabled = context.state.defaultDisclaimerEnabled;
    try {
      var _context;
      context.commit(REMOVE_DISCLAIMER, {
        id
      });
      context.commit(SET_DEFAULT_DISCLAIMER_ENABLED, defaultDisclaimerEnabled);
      const disclaimers = _flatMapInstanceProperty(_context = context.state.disclaimers.allIds).call(_context, disclaimerId => {
        if (disclaimerId === DEFAULT_DISCLAIMER_ID) return [];
        return context.state.disclaimers.byId[disclaimerId];
      });
      if (isBrokerage) await putBrokerageDisclaimers(disclaimers, defaultDisclaimerEnabled);else await putDisclaimers(disclaimers, defaultDisclaimerEnabled);
    } catch (e) {
      context.commit(SET_DISCLAIMERS, {
        disclaimers: oldDisclaimers
      });
      context.commit(SET_DEFAULT_DISCLAIMER_ENABLED, oldDefaultDisclaimerEnabled);
      Err.handle(e, context, "errorDeletingDisclaimer");
    }
  },
  [CREATE_DISCLAIMER]: async (context, {
    isBrokerage,
    newDisclaimer
  }) => {
    const id = uuidv4();
    const defaultDisclaimerEnabled = context.state.defaultDisclaimerEnabled;
    try {
      var _context2;
      context.commit(ADD_DISCLAIMER, {
        disclaimer: _objectSpread(_objectSpread({}, newDisclaimer), {}, {
          id
        })
      });
      const disclaimers = _flatMapInstanceProperty(_context2 = context.state.disclaimers.allIds).call(_context2, disclaimerId => {
        if (disclaimerId === DEFAULT_DISCLAIMER_ID) return [];
        return context.state.disclaimers.byId[disclaimerId];
      });
      if (isBrokerage) await putBrokerageDisclaimers(disclaimers, defaultDisclaimerEnabled);else await putDisclaimers(disclaimers, defaultDisclaimerEnabled);
    } catch (e) {
      context.commit(REMOVE_DISCLAIMER, {
        id
      });
      Err.handle(e, context, "errorCreatingDisclaimer");
    }
  },
  [UPDATE_DEFAULT_DISCLAIMER_ENABLED]: async (context, {
    isBrokerage,
    defaultDisclaimerEnabled
  }) => {
    const oldDefaultDisclaimerEnabled = context.state.defaultDisclaimerEnabled;
    try {
      var _context3;
      const disclaimers = _flatMapInstanceProperty(_context3 = context.state.disclaimers.allIds).call(_context3, disclaimerId => {
        if (disclaimerId === DEFAULT_DISCLAIMER_ID) return [];
        return context.state.disclaimers.byId[disclaimerId];
      });
      context.commit(SET_DEFAULT_DISCLAIMER_ENABLED, defaultDisclaimerEnabled);
      if (isBrokerage) await putBrokerageDisclaimers(disclaimers, defaultDisclaimerEnabled);else await putDisclaimers(disclaimers, defaultDisclaimerEnabled);
    } catch (e) {
      context.commit(SET_DEFAULT_DISCLAIMER_ENABLED, oldDefaultDisclaimerEnabled);
      Err.handle(e, context, "errorEnablingDisclaimer");
    }
  },
  [UPDATE_DISCLAIMER]: async (context, {
    isBrokerage,
    disclaimer
  }) => {
    const oldDisclaimers = context.state.disclaimers;
    const defaultDisclaimerEnabled = context.state.defaultDisclaimerEnabled;
    try {
      var _context4;
      const disclaimers = _flatMapInstanceProperty(_context4 = context.state.disclaimers.allIds).call(_context4, disclaimerId => {
        if (disclaimerId === DEFAULT_DISCLAIMER_ID) return [];
        if (disclaimerId === disclaimer.id) return disclaimer;
        return context.state.disclaimers.byId[disclaimerId];
      });
      context.commit(updateDisclaimer, {
        disclaimer
      });
      if (isBrokerage) await putBrokerageDisclaimers(disclaimers, defaultDisclaimerEnabled);else await putDisclaimers(disclaimers, defaultDisclaimerEnabled);
    } catch (e) {
      context.commit(SET_DISCLAIMERS, {
        disclaimers: oldDisclaimers
      });
      Err.handle(e, context, "errorUpdatingDisclaimer");
    }
  }
};
export default actions;